import { NgModule } from '@angular/core';
import { CopyClipboardDirective } from './copy-clipboard.directive';

@NgModule({
  imports: [],
  exports: [CopyClipboardDirective],
  declarations: [CopyClipboardDirective],
  providers: [],
})
export class CopyClipboardModule {}
